"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RyersonLogo = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var RyersonLogoSvg_1 = __importDefault(require("./svgWrappers/RyersonLogoSvg"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var RyersonLogo = function RyersonLogo(_ref) {
  var className = _ref.className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "240px" : _ref$width,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "blue" : _ref$color,
      onClick = _ref.onClick;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      secondaryBrand = _theme$colors$primary.secondaryBrand,
      white = _theme$colors$primary.white;
  var logoColor = color === "blue" ? secondaryBrand : white;
  var cursor = onClick ? "pointer" : "default";
  return (0, jsx_runtime_1.jsx)(RyersonLogoSvg_1.default, {
    width: width,
    className: className,
    color: logoColor,
    cursor: cursor,
    onClick: onClick
  });
};

exports.RyersonLogo = RyersonLogo;